// Quais tipos de atendimento valem para cada tipo de boleto.
//
// Os atendimentos BBN ('bbn-alta' e 'bbn-media') existem só para o boleto
// 'BBN - DWDM FSPO'. Eles mudam o comportamento do sistema em vários pontos —
// filtram os GMOs para os de BBN, dispensam a validação de estoque ao adicionar
// item e exigem a data "BBN Aberto Em" —, então um pedido com atendimento BBN
// e boleto comum entra errado em todos eles.
//
// Mesma tabela de vision_be/enums/TipoAtendimentoPorBoleto.js, que é quem
// garante a regra de verdade. Aqui ela serve para a tela não oferecer uma opção
// que o backend vai recusar.
export const ATENDIMENTOS_BBN = ['bbn-alta', 'bbn-media'];
export const ATENDIMENTOS_PADRAO = ['vital', 'programado'];

// Único boleto que aceita — e exige — atendimento BBN.
export const BOLETO_BBN = 'bbn-dwdm-fspo';

// Tipos de atendimento permitidos para um tipo de boleto.
export function atendimentosPermitidos(tipoBoleto) {
    return tipoBoleto === BOLETO_BBN ? ATENDIMENTOS_BBN : ATENDIMENTOS_PADRAO;
}

// O atendimento escolhido continua válido para o boleto selecionado?
export function atendimentoValido(tipoBoleto, tipoAtendimento) {
    if (!tipoAtendimento || tipoAtendimento === '0') return true; // nada escolhido ainda
    return atendimentosPermitidos(tipoBoleto).includes(tipoAtendimento);
}

const TipoAtendimentoPorBoleto = { ATENDIMENTOS_BBN, ATENDIMENTOS_PADRAO, BOLETO_BBN, atendimentosPermitidos, atendimentoValido };

export default TipoAtendimentoPorBoleto;
